import { render, staticRenderFns } from "./customer-type-selector.vue?vue&type=template&id=404e57e6&"
import script from "./customer-type-selector.vue?vue&type=script&lang=js&"
export * from "./customer-type-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports